import React from "react";
import { ShoppingBag, MessageCircle } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { formatCLP, WHATSAPP_LINK } from "../lib/api";
import { toast } from "sonner";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const isQuote = product.price === null || product.price === undefined;

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="group relative bg-white border-2 border-black rounded-3xl flex flex-col transition-all duration-300 hover:-translate-y-2 hover:rotate-[-0.5deg] hover:shadow-[8px_8px_0_0_#0A0A0A] overflow-hidden"
    >
      <div className="relative overflow-hidden bg-mint-light aspect-square">
        <img
          src={product.image_url}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {product.featured && (
          <span className="absolute top-3 left-3 bg-yolk text-black text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 border-2 border-black rounded-full">
            ⭐ Top
          </span>
        )}
        {isQuote && (
          <span className="absolute top-3 right-3 bg-black text-yolk text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 border-2 border-black rounded-full">
            Cotizar
          </span>
        )}
      </div>

      <div className="p-4 flex flex-col flex-1">
        <span className="text-[10px] uppercase tracking-[0.18em] text-mint-deep font-bold mb-1.5">
          {product.category}
        </span>
        <h3 className="font-heading text-base font-bold text-brand-ink leading-tight mb-1.5">
          {product.name}
        </h3>
        <p className="text-xs text-gray-500 leading-relaxed line-clamp-2 mb-3 flex-1">
          {product.description}
        </p>

        <div className="flex items-center justify-between gap-2 mt-auto pt-3 border-t-2 border-black">
          <p className="font-heading text-lg font-bold text-brand-ink">
            {formatCLP(product.price)}
          </p>
          {isQuote ? (
            <a
              href={WHATSAPP_LINK(`Hola, quiero cotizar: ${product.name}`)}
              target="_blank"
              rel="noreferrer"
              data-testid={`quote-wa-btn-${product.id}`}
              className="btn-chunky inline-flex items-center gap-1.5 bg-[#25D366] text-white text-xs font-bold px-4 py-2 hover:bg-[#1faa54]"
            >
              <MessageCircle className="h-3 w-3" />
              Cotizar
            </a>
          ) : (
            <button
              onClick={() => {
                addItem(product);
                toast.success(`${product.name} agregado 🎉`);
              }}
              data-testid={`add-to-cart-btn-${product.id}`}
              className="btn-chunky inline-flex items-center gap-1.5 bg-mint-deep hover:bg-mint text-white text-xs font-bold px-4 py-2"
            >
              <ShoppingBag className="h-3 w-3" />
              Agregar
            </button>
          )}
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
